import ReactDOM from 'react-dom';
// PJ's project-page give-widget-setup functions originally defined for the sake of an A/B test that made adding a
// donation to your cart from the project page an AJAX-based process.
//
// See also: giveWidgetFunctions.js, giveWidgetOverrides.js.
import { fullCartCheck } from './fullCartHandlerMain.js';
import { AddedToCart } from '../common/AddedToCart.js';
import { ajaxAddToCartSubmit } from '../giveWidget/giveWidgetFunctions.js';


export function isMultiProjectGiving() {
	return typeof isEligibleForFunding != "undefined" && isEligibleForFunding;
}

// Sets up various on-add-to-cart event handlers.
export const main = () => {
	document.body.addEventListener("click", function (e) {
		var donationAmount = 0;
		var cls = e.target.classList;
		var isMobile = $(e.target).parents(".js-mobile-donation-box").length > 0;

		switch (true) {
			case $(e.target).parents(".js-suggested-amount-to-complete").length > 0: // cost to complete parent
				donationAmount = $(e.target).closest('form').find('[name=donationAmount]').val();
				showCart(e, donationAmount);
				break;
			case cls.contains("give-button"): //normal give button
				donationAmount = e.target.parentNode.previousElementSibling.value;
				showCart(e, donationAmount);
				break;
			case isMobile && (cls.contains("suggested-amount") || cls.contains("suggestedAmount")): //suggested mobile amt
				donationAmount = $(e.target).text();
				showCart(e, donationAmount);
				break;
			case cls.contains("suggestedAmount"): //suggested desktop cmplt amt
				donationAmount = $(e.target).closest('form').find('[name=donationAmount]').val();
				showCart(e, donationAmount);
				break;
			case cls.contains("js-match-tooltip"):
				donationAmount = $('.js-completing-amount').text().replace("$", "");
				$("#donationAmount").val(donationAmount);
				showCart(e, donationAmount);
				break;
			default:
				break;
		}
	});

	function addToCart() {
		var frm = $("#simpleWidgetForm")[0];
		if (frm) {
			ajaxAddToCartSubmit(frm, fullCartCheck);
			// on search, the form is hidden and a success message displayed
			// for this project page test, keep the form visible
			$(frm).show();
		}
	}

	function showCart(event, amt) {
		if(amt > 0 && isMultiProjectGiving()) {
			event.preventDefault();
			// *Conditionally* trigger an ajax request adding item to cart
			addToCart();

			// only retrieves previous searchURL, can't getSuggestedProjects since it's async
			var searchURL = readCookie('searchTermsURL') ? readCookie('searchTermsURL') : baseURL + 'donors/search.html';
			var teacherId = (typeof teachersOnPage != "undefined") ? teachersOnPage[0] : null;
			if (teacherId && searchURL.indexOf(teacherId) > -1) {
				searchURL = (new Uri(baseURL + "donors/search.html")).addQueryParam("cityName", schoolCity).addQueryParam("state", schoolState).toString();
			}

			const targetDiv = document.getElementById('js-added-to-cart-container');
			const onClose = () => {
				// On close, modify the mini-cart div from genHeader.tag: proc the on-hover behavior (show a box with
				// extra details re what is in your cart) for the next 3 seconds only.
				$('.mini-cart').addClass("show-message");
				setTimeout(() => {
					$('.mini-cart').removeClass("show-message");
				}, "3000");
				ReactDOM.unmountComponentAtNode(targetDiv);
			}
			ReactDOM.render(
				<AddedToCart amount={amt} searchUrl={searchURL} onClose={onClose} />,
				targetDiv,
			);

			// Reset donationAmount
			if (document.getElementById('donationAmount')) {
				document.getElementById('donationAmount').value = '';
			}
		}
	}

	$("body").on("keyup", "[name=donationAmount]", function(event) {
		if (isEnterKey(event)) {
			var donationAmount = $(event.target).val();
			showCart(event, donationAmount);
		}
	});

	function isEnterKey(event) {
		return (event.key == "Enter");
	}
};
